import { Button } from "src/components/ui/button";
import { SheetClose } from "src/components/ui/sheet";
import { Formik, useFormikContext } from "formik";
import { PERMISSIONS } from "src/lib/constants";
import * as Yup from "yup";
import CustomCheckBox from "../CustomCheckBox";
import CustomInput from "../CustomInput";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createRole, updateRole } from "src/api/settings";
import { showSuccessToast } from "src/lib/utils";
import { usePortalContext } from "src/context/PortalContext";

const validationSchema = Yup.object().shape({
	permissions: Yup.array().of(Yup.string().required()).required(),
});
const CreateRole = ({ role }) => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const initialValues = {
		...(!!role && { uuid: role.uuid }),
		name: role?.name ?? "",
		permissions: role?.permissions ?? [],
	};

	const { mutate, isLoading } = useMutation(role ? updateRole : createRole, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["roles"]);
			queryClient.invalidateQueries(["user"]);
			closePortal();
		},
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ handleSubmit, values, handleChange }) => (
				<form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-6">
					<CustomInput name="name" value={values.name} onChange={handleChange} label="Role Name" placeholder="Role Name" />
					<div className="tw-grid tw-gap-2">
						<p className="tw-text-lg tw-font-semibold">Select Permissions</p>
						{PERMISSIONS.map((permission, index) => (
							<Permission permission={permission} key={index} />
						))}
					</div>
					<div className="tw-flex tw-items-center tw-justify-end tw-gap-4 tw-mt-3">
						<SheetClose asChild>
							<Button type="button" variant="ghost">
								Cancel
							</Button>
						</SheetClose>
						<Button disabled={isLoading}>Save</Button>
					</div>
				</form>
			)}
		</Formik>
	);
};

const Permission = ({ permission }) => {
	const { values, handleChange } = useFormikContext();

	return (
		<CustomCheckBox
			type="checkbox"
			id={`group-${permission}`}
			className="tw-size-4 tw-border-border"
			checked={values.permissions?.includes(permission)}
			name="permissions"
			onChange={handleChange}
			value={permission}
			label={permission?.replaceAll("_", " ")}
			labelClassName="tw-capitalize"
		/>
	);
};

export default CreateRole;
